import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useResendEmailConfirmations = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const resendEmailConfirmations = async (userIds: string[]) => {
    const response = await fetch(
      `${APIBaseChronos}/api/user/resend-email-confirmation`,
      getFetchConfig({ method: FetchMethod.POST, data: { userIds } }),
    );
    if (!response.ok) throw new Error(`Failed to resend confirmation emails: ${response.status}`);
  };

  return useMutation(resendEmailConfirmations, {
    onSuccess: (_data, userIds) => {
      toast.success(`Confirmation ${userIds.length === 1 ? 'email' : 'emails'} sent successfully`);
    },
    onError: () => {
      toast.error('Failed to resend confirmation emails');
    },
  });
};
